/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The kind of heat exchanger.
 */
export const AnimaticHeatExchangerConfigKind = {
  PlateFin: "plate-fin",
  PlateFrame: "plate-frame",
  ShellTube: "shell-tube",
  TubeTube: "tube-tube",
} as const;
/**
 * The kind of heat exchanger.
 */
export type AnimaticHeatExchangerConfigKind = OpenEnum<
  typeof AnimaticHeatExchangerConfigKind
>;

/**
 * The configuration of the animatic for a heat exchanger.
 */
export type AnimaticHeatExchangerConfig = {
  /**
   * The kind of heat exchanger.
   */
  kind: AnimaticHeatExchangerConfigKind;
};

/** @internal */
export const AnimaticHeatExchangerConfigKind$inboundSchema: z.ZodType<
  AnimaticHeatExchangerConfigKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticHeatExchangerConfigKind);
/** @internal */
export const AnimaticHeatExchangerConfigKind$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticHeatExchangerConfigKind
> = openEnums.outboundSchema(AnimaticHeatExchangerConfigKind);

/** @internal */
export const AnimaticHeatExchangerConfig$inboundSchema: z.ZodType<
  AnimaticHeatExchangerConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  kind: AnimaticHeatExchangerConfigKind$inboundSchema,
});
/** @internal */
export type AnimaticHeatExchangerConfig$Outbound = {
  kind: string;
};

/** @internal */
export const AnimaticHeatExchangerConfig$outboundSchema: z.ZodType<
  AnimaticHeatExchangerConfig$Outbound,
  z.ZodTypeDef,
  AnimaticHeatExchangerConfig
> = z.object({
  kind: AnimaticHeatExchangerConfigKind$outboundSchema,
});

export function animaticHeatExchangerConfigToJSON(
  animaticHeatExchangerConfig: AnimaticHeatExchangerConfig,
): string {
  return JSON.stringify(
    AnimaticHeatExchangerConfig$outboundSchema.parse(
      animaticHeatExchangerConfig,
    ),
  );
}
export function animaticHeatExchangerConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticHeatExchangerConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticHeatExchangerConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticHeatExchangerConfig' from JSON`,
  );
}
